<script>
import Loader from '@/views/components/loader'
export default {
    components: {
        Loader,
    },
    props: {
        show: Boolean,
    },
    render(h) {
        return h('Loader', {
            props: {
                loader: this.show,
                lineForegroundColor: '#022b4f',
                lineBackgroundColor: '#ffffff',
            },
        })
    },
}
</script>
